import { getDate } from "./date";

export function dateFilter(value, filter, row) {
  const date = getDate(row[filter.columnName]);
  const start = filter.value.start && getDate(filter.value.start);
  const end = filter.value.end && getDate(filter.value.end);
  return (
    (!start || date.isSameOrAfter(start, "day")) &&
    (!end || date.isSameOrBefore(end, "day"))
  );
}
